import axios from './axios'
import moment from 'moment'

const createStory = data => axios.post('/story/text', data)
const getStoryImg = (limit, skip) => axios.get(`/story/image?limit=${limit}&skip=${skip}&contentType=1`)
const getStoryImageCount = () => axios.get('/story/image/count')
const getStorysByType = (id, type) => axios.get(`/story?userUuid=${id}&type=${type}`)
const getStorysById = id => axios.get(`/story?userUuid=${id}`)
const getStorie = storyUuid => axios.get(`/story/${storyUuid}`)

const getBookmark = accessKey => axios.get(`story/bookmark?accessKey=${accessKey}`)
const getLike = accessKey => axios.get(`story/like?accessKey=${accessKey}`)
const createBookmark = data => axios.post('story/bookmark', data)
const createLike = data => axios.post('story/like', data)
const createLikeAnonymous = data => axios.post('story/like/anonymous', data)
const createReport = data => axios.post('story/reports', data)
const deleteStory = (id, accessKey) => axios.delete(`story?accessKey=${accessKey}&uuid=${id}`)
const deleteBookmark = (id, accessKey) => axios.delete(`story/bookmark?accessKey=${accessKey}&uuid=${id}`)
const validateStory = data => axios.post('text/validate', data)
const getStorys = options => axios.get(`/story?userUuid=${options?.id}${options?.type === 0 ? `&type=${options?.type}` : options?.type === 1 ? `&type=${options?.type}` : ''}&group=${options?.storyGroup}&lastAllowedTime=${moment(new Date()).subtract(3, 'minutes')?.valueOf()}&limit=${options.limit}&skip=${options.skip}`)
const listenPodcastLogin = (id, accessKey) => axios.post(`podcast/${id}/listened/logged-in`, {
  accessKey,
})
const getStoryCount = options => axios.get(`/story/count?userUuid=${options?.id}${options?.type === 0 ? `&type=${options?.type}` : options?.type === 1 ? `&type=${options?.type}` : ''}&group=${options?.storyGroup}&lastAllowedTime=${moment(new Date()).subtract(3, 'minutes')?.valueOf()}&limit=${options.limit}&skip=${options.skip}`)
const listenPodcastNoLogin = id => axios.post(`podcast/${id}/listened/not-logged-in`)

const getCountListenPodcast = () => axios.get('/podcast/listened')

const isCheckedPodcast = (id, accessKey) => axios.get(`/podcast/${id}/reaction/exists?accessKey=${accessKey}`)

const getReactionStatistic = (id, accessKey) => axios.get(`/podcast/${id}/reaction/statistic?accessKey=${accessKey}`)
const getReactionStories = (id, accessKey, feedback) => axios.get(`/story/podcast/${id}?accessKey=${accessKey}&feedback=${feedback}`)
const sendReactionPodcast = (id, data) => axios.post(`/podcast/${id}/reaction`, data)

const obj = {
  getStoryImg,
  createStory,
  getStorys,
  getStorie,
  createBookmark,
  createLike,
  getBookmark,
  getLike,
  getStorysById,
  deleteStory,
  deleteBookmark,
  getStorysByType,
  createReport,
  validateStory,
  getStoryImageCount,
  listenPodcastLogin,
  listenPodcastNoLogin,
  createLikeAnonymous,
  getStoryCount,
  getCountListenPodcast,
  isCheckedPodcast,
  getReactionStatistic,
  getReactionStories,
  sendReactionPodcast,
}

export default obj
